import ShowAnyThing from "../AboutMe/Components/buttonUses";
import { Card } from "flowbite-react";

import backImg from '../../pic/try2.jpg'
import pic1 from '../../pic/portfolio/FireShot Capture 041 - Kerlos Magdy - kerlos-magdy-1999.netlify.app.png'
import pic2 from '../../pic/portfolio/FireShot Capture 039 - Redak - stirring-youtiao-44a8cd.netlify.app.png'
import pic3 from '../../pic/portfolio/FireShot Capture 042 - Weather - weather-api-kero.netlify.app.png'
import pic4 from '../../pic/portfolio/FireShot Capture 040 - Home - freelancewebsite132.netlify.app.png'

export default function Portfolio(){
    const projects = [
        {
            name:"Last Portfolio",
            link:"https://kerlos-magdy-1999.netlify.app/",
            github:"https://github.com/KerlosSoNy/Zoniix-Port",
            img:pic1,
            desc:"Simple Portfolio To Try New Technologies"
        },
        {
            name:"Redak Hospital",
            link:"https://stirring-youtiao-44a8cd.netlify.app/",
            github:"https://github.com/KerlosSoNy/Redak-project",
            img:pic2,
            desc:"Hospital System to help you to make appointment with hospitals (Need data base to make an appointments)"
        },
        {
            name:"Weather App",
            link:"https://weather-api-kero.netlify.app/",
            github:"https://github.com/KerlosSoNy/Weather",
            img:pic3,
            desc:'Simple Weather website to help you to know the weather right now in any place in the world'
        },
        {
            name:"Freelance Website",
            link:"https://freelancewebsite132.netlify.app/",
            github:"https://github.com/KerlosSoNy/New-Project-By-Booststarb",
            img:pic4,
            desc:'Simple freelancing website to help you to show your service'
        },
    ]
    return(
        <div className="mt-32 relative" id="portfolio">
            {/* <img src={backImg} className="w-full absolute h-full" alt="backImg " /> */}
            <div className="w-full z-40 relative py-20">
                <ShowAnyThing name={"PORTFOLIO"}/>
                <div className="lg:w-2/3 md:w-full w-full 
                mx-auto grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 
                mt-14 
                xl:ps-24 lg:ps-4 md:ps-4 ps-3">
                    {projects.map((e)=>{
                        return(
                            <div>
                                    <Card
                                        className="max-w-sm m-5 border-0"
                                        imgAlt="Meaningful alt text for an image that is not purely decorative"
                                        imgSrc={e.img}
                                        >
                                        <h5 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                                            {e.name}
                                        </h5>
                                        <p className="font-normal text-gray-700 dark:text-gray-400 h-20">
                                            {e.desc}
                                        </p>
                                        <div className=" flex flex-row w-full text-center h-10">
                                            <a href={e.link} target='_blank' rel="noreferrer" className=" text-white font-semibold bg-cyan-900 w-1/2 py-2 border-r-2 border-black rounded-l-lg hover:scale-105">Visite</a>
                                            <a href={e.github} target='_blank' rel="noreferrer" className=" text-white font-semibold bg-cyan-900  w-1/2 py-2 rounded-r-lg hover:scale-105">Code</a>
                                        </div>
                                    </Card>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}